
import { defineComponent, ref } from 'vue'
import Button from '@/components/btn.vue'
import { useToast } from 'vue-toastification'

export default defineComponent({
  components: {
    Button
  },
  setup () {
    const toast = useToast()
    const btnState = ref(true)
    const subscribe = () => {
      toast.info('Comming soon')
      btnState.value = false
    }
    return {
      btnState,
      subscribe
    }
  }
})
